export const appConfig = {
  default_mode: "dark",
  languages: ["en", "de"],
  contact_form_url: "https://formspree.io/f/xnqyrwgy",
};
